import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Threshold mínimo de horas para alertar terapeuta
 */
export const LOW_CREDIT_THRESHOLD_HOURS = 0.5;

/**
 * Interface para dados de crédito do usuário
 */
interface CreditBalances {
  hours?: number;
  sessions?: {
    constellation?: number;
    participation?: number;
  };
}

interface UserCreditData {
  creditBalances?: CreditBalances;
}

/**
 * Hook para monitorar saldo de créditos em tempo real
 */
export const useCreditBalance = (userId: string | null | undefined, enabled: boolean = true) => {
  const [hoursBalance, setHoursBalance] = useState<number | null>(null);
  const [isLowBalance, setIsLowBalance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !enabled) {
      setHoursBalance(null);
      setIsLowBalance(false);
      setLoading(false);
      return;
    }

    setLoading(true);

    const userRef = doc(db, "users", userId);
    const unsubscribe = onSnapshot(
      userRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data() as UserCreditData;
          const hours = data.creditBalances?.hours ?? 0;
          
          setHoursBalance(hours);
          setIsLowBalance(hours <= LOW_CREDIT_THRESHOLD_HOURS);
        } else {
          setHoursBalance(0);
          setIsLowBalance(true);
        }
        setLoading(false);
      },
      (error) => {
        console.error("Erro ao monitorar saldo de créditos:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userId, enabled]);

  return {
    hoursBalance,
    isLowBalance,
    loading,
  };
};
